<template>
  <a-form :form="form" :labelCol="{span: 3, offset: 3}" :wapperCol="{span: 17}">
    <a-form-item label="首次必中">
      <a-switch v-decorator="['first_mark', {initialValue: false, valuePropName: 'checked' }]" />
    </a-form-item>
    <!--    <a-form-item label="白名单必中">-->
    <!--      <a-switch v-decorator="['with', { valuePropName: 'checked' }]" />-->
    <!--    </a-form-item>-->
    <!--    <a-form-item label="黑名单不中">-->
    <!--      <a-switch v-decorator="['black', { valuePropName: 'checked' }]" />-->
    <!--    </a-form-item>-->
    <a-form-item label="每日首次必中">
      <a-switch v-decorator="['today_first_mark', { initialValue: false,valuePropName: 'checked' }]" />
    </a-form-item>
    <a-form-item label="N次必中">
      <a-input-number
        v-decorator="['n_times_mark',{initialValue: 2}]"
        :min="1"
        :formatter="value => `${value}次`"
        :parser="value => value.replace('次', '')"/>
    </a-form-item>
    <a-form-item label="N天必中">
      <a-input-number
        v-decorator="['n_days_mark',{initialValue: 2}]"
        :min="1"
        :formatter="value => `${value}天`"
        :parser="value => value.replace('天', '')"/>
    </a-form-item>
    <a-form-item label="保底中奖概率">
      <a-input-number
        v-decorator="['guaranteed_probability',{initialValue: 60}]"
        :min="1"
        :max="100"
        :formatter="value => `${value}%`"
        :parser="value => value.replace('%', '')"/>
    </a-form-item>
  </a-form>
</template>
<script>
import PageView from '@/layouts/PageView'
import { LuckyAPI } from '@/api/lucky'
const props = {
  robotId: [Number, String]
}
export default {
  components: { PageView },
  data () {
    return {
      form: this.$form.createForm(this, { name: 'config' })
    }
  },
  props,
  methods: {
    getData() {
      return LuckyAPI.getConfig({
        sub_id: this.robotId
      }).then(({ code, msg, data }) => {
        if (code === 1) {
          this.$nextTick().then(() => {
            this.form.setFieldsValue({
              first_mark: !!data.first_mark,
              today_first_mark: !!data.today_first_mark,
              n_times_mark: data.n_times_mark,
              n_days_mark: data.n_days_mark,
              guaranteed_probability: data.guaranteed_probability
            })
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    submit() {
      return new Promise(resolve => {
        this.form.validateFields((err, values) => {
          if (!err) {
            const { n_times_mark, n_days_mark, guaranteed_probability } = values
            LuckyAPI.saveConfig({
              first_mark: Number(values.first_mark),
              today_first_mark: Number(values.today_first_mark),
              n_times_mark,
              n_days_mark,
              guaranteed_probability,
              sub_id: this.robotId
            }).then(res => {
              if (res.code === 1) {
                resolve([null, res.data])
              } else {
                resolve([res.msg, null])
              }
            })
          } else {
            resolve([err, null])
          }
        })
      })
    }
  }
}
</script>
